import React, { Component } from 'react'
import RemoveButton from '../removeButton'
import './image.scss'

class Image extends Component {

  constructor (props) {
    super(props)
    this.onDelete = this.onDelete.bind(this)
  }

  onDelete (e) {
    if (typeof this.props.onClickDelete === 'function') {
      this.props.onClickDelete(this.props.imageFile)
    }
  }

  render () {
    if (this.props.imageFile === null) return null
    let imageFile = this.props.imageFile
    if (!imageFile.IsImage) return null
    let canDelete = typeof this.props.onClickDelete === 'function' && (imageFile.IsDeletable === undefined || imageFile.IsDeletable)
    return (
      <div className='element-image'>
        <a href={imageFile.FileURL} data-lightbox='gallery' data-title={imageFile.FileName}><img className='thumb' src={imageFile.ThumbURL} /></a>
        {canDelete && <div className='file-delete'><RemoveButton onClick={this.onDelete} size='s' /></div>}
      </div>
    )
  }
}

Image.defaultProps = {
  imageFile: null,
  onClickDelete: null
}

export default Image




// WEBPACK FOOTER //
// ./src/app/shared/elements/image/index.js